export default __webpack_public_path__ + "static/media/bg-food.53daafae.png";